import { createContext } from 'react';

var context=/*#__PURE__*/createContext("asphalt");var Provider=context.Provider;var Consumer=context.Consumer;

export default context;
export { Consumer, Provider };
